// extracted by mini-css-extract-plugin
export var logo = "_is-2";
export var logoWrapper = "_is-1";
export var strip = "_is-0";